export const copyToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
        alert("Email copiata negli appunti!");
    } catch (err) {
        console.error("Errore nella copia", err);
    }
};